import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from "vue";
import {
  ApprovalShift,
  ApprovalVacationUser
} from "@/models/approval/ApprovalResponse";
import { EnumWorkClassification } from "@/models/enum/Enum";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "../table/ApprovalChip.vue";
import TimeList from "@/components/list/TimeList.vue";
import { VacationFlowDat } from "@/models/transaction/VacationFlowDat";

type Props = {
  dat: VacationFlowDat;
  approvals: ApprovalVacationUser[];
  shift: ApprovalShift;
  affiliation: string | undefined;
};

type halfholidayKbn = typeof halfholidayKbn[keyof typeof halfholidayKbn];
// 半休区分の選択肢

export default /*#__PURE__*/_defineComponent({
  __name: 'VacationExpandItem',
  props: {
    dat: null,
    approvals: null,
    shift: null,
    affiliation: null
  },
  setup(__props: any) {

const props = __props as {
  dat: VacationFlowDat;
  approvals: ApprovalVacationUser[];
  shift: ApprovalShift;
  affiliation: string | undefined;
};



const vacationKbn = computed(() => {
  const vKbn = [
    { text: "有給", value: EnumWorkClassification.PAID_HOLIDAY },
    { text: "欠勤", value: EnumWorkClassification.ABSENCE_DAY },
    { text: "特別休暇", value: EnumWorkClassification.SPECIAL_HOLIDAY },
    { text: "その他", value: EnumWorkClassification.OTHER }
    // { text: "計画有給", value: EnumWorkClassification.PAID_SCHEDULE_HOLIDAY }
  ];

  if (props.affiliation?.indexOf("事務所") === 0) {
    return [
      ...vKbn.slice(0, 1),
      { text: "半休", value: EnumWorkClassification.PAID_HALF_HOLIDAY },
      ...vKbn.slice(1)
    ];
  } else {
    return vKbn;
  }
});

const isVacationKbnPaidHalfHoliday = computed(
  () => props.dat?.vacationKbn === EnumWorkClassification.PAID_HALF_HOLIDAY
);

// 半休区分の定数
const halfholidayKbn = {
  am: "0",
  pm: "1"
} as const;
const halfHolidayTypes = [
  { text: "午前休", value: halfholidayKbn.am },
  { text: "午後休", value: halfholidayKbn.pm }
];

const ReasonKbn = {
  self: "1",
  ceremonial: "2",
  special: "3"
} as const;

const reasonKbn = [
  { text: "私用", value: ReasonKbn.self },
  { text: "慶弔", value: ReasonKbn.ceremonial },
  { text: "特別", value: ReasonKbn.special }
];

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date?: string | null) => {
  return date
    ? DateTime.fromISO(date)
        .setLocale("ja")
        .toFormat("yyyy年MM月dd日(EEE)")
    : "";
};

const formatDateTime = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};

return { __sfc: true,props, vacationKbn, isVacationKbnPaidHalfHoliday, halfholidayKbn, halfHolidayTypes, ReasonKbn, reasonKbn, shiftHeader, approvalHeaders, formatDate, formatDateTime, ApprovalChip, TimeList }
}

})